export const environment = import.meta.env.VITE_ENVIRONMENT;
export const apiBaseUrl = import.meta.env.VITE_API_URL;
export const appBaseUrl = import.meta.env.VITE_BASE_URL;
export const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;